module.exports = __webpack_public_path__ + "static/img/3053_phase_function_Paper_PointsHejduk_Prediction.a4d29a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3053_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Vh05
// module chunks = 0